import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Tailwind-aware className merge used by every UI component. */
export function cn(...inputs: Array<ClassValue>): string {
  return twMerge(clsx(inputs))
}

export function formatOvers(balls: number): string {
  const completedOvers = Math.floor(balls / 6)
  const remainingBalls = balls % 6
  return `${completedOvers}.${remainingBalls}`
}

export function calculateRunRate(runs: number, legalBalls: number): string {
  if (legalBalls === 0) return '0.00'
  const overs = legalBalls / 6
  return (runs / overs).toFixed(2)
}

export function calculateEconomyRate(runs: number, legalBalls: number): string {
  if (legalBalls === 0) return '0.00'
  const overs = legalBalls / 6
  return (runs / overs).toFixed(2)
}

export function calculateStrikeRate(runs: number, balls: number): string {
  if (balls === 0) return '0.00'
  return ((runs / balls) * 100).toFixed(2)
}
